import { Backdrop, CircularProgress } from '@mui/material'
import { useContext } from 'react'
import { AppContext } from '../../store/AppProvider'

export const AppLoader = () => {
    const { showLoader } = useContext(AppContext)
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
            open={showLoader}
        >
            <CircularProgress size="5rem" />
        </Backdrop>
    )
}
